// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3XUqz","legacyBtn":"MutateMid_legacyBtn__MQMfA"};